import { customerMonitoredStatus } from "Models/Enums";
import React from "react";
import { Tooltip } from "Views/Components/Tooltip/Tooltip";

export function withMonitoring<T>(status: customerMonitoredStatus, callback: () => T): T | string {
	if (status === 'MONITORED') {
		return callback();
	}
	return "*****";
}

type Props = {
	status: customerMonitoredStatus;
	displayType?: 'icon' | 'tooltip' | 'content';
	content?: string;
	showTooltip?: boolean;
	hideIcon?: boolean;
	children?: React.ReactNode;
}

export const MonitoredSection: React.FunctionComponent<Props> = ({
	status,
	showTooltip = false,
	displayType = 'content',
	content,
	hideIcon = false,
	children
}) => {
	if (status === 'MONITORED') {
		return <>{children}</>;
	}

	const tooltipContent = content ?? "Unlock this data by monitoring your customer.";
	// for icon display type, we explicty set the icon
	if (displayType === 'icon') {
		return (
			<div className='locked-icon'>
				{showTooltip && <Tooltip id="locked-icon-tooltip" content={tooltipContent} />}
			</div>
		);
	}

	if (displayType === 'tooltip') {
		return <Tooltip id="monitored-section-tooltip" content={tooltipContent} />
	}

	if (!!content && displayType === 'content') {
		return (
			<div className="not-monitored-section">
				{!hideIcon && (
					<div className='locked-icon'>
						{showTooltip && <Tooltip id="locked-icon-tooltip" content={content} />}
					</div>
				)}
				{content && <p>{content}</p>}
			</div>
		);
	}

	// If no content is provided, we return an empty fragment
	// this can be used as a placeholder in UI for monitoring customer
	return <></>;
};